import {
  HomeIcon,
  ChatBubbleLeftRightIcon,
  CalendarIcon,
  CreditCardIcon,
  PlayIcon,
  UserGroupIcon,
  UserIcon,
  CogIcon,
  SparklesIcon,
  BuildingOfficeIcon,
  DocumentTextIcon,
  RectangleStackIcon,
  ChartBarIcon,
  EnvelopeIcon,
  MapPinIcon,
  CalendarDaysIcon,
} from '@heroicons/react/24/outline';

const primaryNavigation = [
  { name: 'Dashboard', href: '/dashboard', icon: HomeIcon },
  { name: 'Team Chat', href: '/chat', icon: ChatBubbleLeftRightIcon },
  { name: 'Calendar', href: '/events', icon: CalendarIcon },
  { name: 'Team Roster', href: '/roster', icon: UserGroupIcon },
  { name: 'Uniforms', href: '/uniforms', icon: RectangleStackIcon },
  { name: 'Payments', href: '/payments', icon: CreditCardIcon },
  { name: 'Videos', href: '/videos', icon: PlayIcon },
  { name: 'AI Video Analysis', href: '/video-analysis', icon: SparklesIcon },
  { name: 'Profile', href: '/profile', icon: UserIcon },
];

const invoicingNavigation = [
  { name: 'Invoicing', href: '/invoicing', icon: DocumentTextIcon },
];

const paymentSettingsNavigation = [
  { name: 'Stripe Settings', href: '/stripe-settings', icon: CreditCardIcon },
];

const coachNavigation = [
  { name: 'Team Management', href: '/team-management', icon: CogIcon },
];

const orgAdminNavigation = [
  { name: 'Organization Management', href: '/organization-management', icon: BuildingOfficeIcon },
  { name: 'Programs', href: '/programs', icon: RectangleStackIcon },
  { name: 'Facilities', href: '/facilities', icon: MapPinIcon },
  { name: 'Scheduling', href: '/scheduling', icon: CalendarDaysIcon },
  { name: 'Contacts', href: '/contacts', icon: EnvelopeIcon },
  { name: 'User Management', href: '/user-management', icon: UserGroupIcon },
  { name: 'League Reports', href: '/league-reports', icon: ChartBarIcon },
];

const appManagerNavigation = [
  { name: 'App Management', href: '/app-management', icon: CogIcon },
];

const parentNavigation = [
  { name: 'My Players', href: '/parent-dashboard', icon: UserIcon },
];

export const getSidebarSections = ({ role, isCoach = false, isParent = false }) => {
  const sections = [
    {
      key: 'primary',
      items: [
        ...primaryNavigation,
        ...((isCoach || ['admin', 'org_admin', 'app_manager'].includes(role)) ? invoicingNavigation : []),
        ...(role === 'app_manager' ? paymentSettingsNavigation : []),
      ],
    },
  ];

  if (isCoach || role === 'admin' || role === 'org_admin') {
    sections.push({ key: 'coach', items: coachNavigation });
  }

  if (role === 'org_admin') {
    sections.push({ key: 'org_admin', items: orgAdminNavigation });
  }

  if (role === 'app_manager') {
    sections.push({ key: 'app_manager', items: appManagerNavigation });
  }

  if (isParent) {
    sections.push({ key: 'parent', items: parentNavigation });
  }

  return sections.filter((section) => section.items.length > 0);
};
